import { type ReactNode } from 'react';
import { type EarningsData, EarningsSections } from './earnings-sections';
import { PaymentProgressCard } from './earnings-progress-card';
import { AccumulatedTable } from './accumulated-table';
import { FailureStateBanner } from './failure-state-banner';
import { StatusCard } from './status-card';
import { BonusIndicators } from './bonus-indicators';

type Props = EarningsData;

function AccumulatedAndStatus({ props }: { props: Props }): ReactNode {
  return (
    <div className="grid grid-cols-1 gap-sm md:grid-cols-[1fr_2fr]">
      <StatusCard summary={props.summary} daily={props.daily} />
      <AccumulatedTable
        summary={props.summary}
        baseEarnings={props.baseEarnings}
      />
    </div>
  );
}

function ResultsHeading(): ReactNode {
  return (
    <h3 className="mb-sm mt-xl text-base font-semibold uppercase tracking-wider text-text-primary">
      Tus resultados
    </h3>
  );
}

export function EarningsContent(props: Props): ReactNode {
  return (
    <div className="space-y-sm">
      <FailureStateBanner summary={props.summary} />
      <PaymentProgressCard summary={props.summary} />
      <BonusIndicators ranking={props.ranking} summary={props.summary} />
      <ResultsHeading />
      <AccumulatedAndStatus props={props} />
      <EarningsSections d={props} />
    </div>
  );
}
